export const STORAGE_KEYS = {
  fcmToken: 'FCM_TOKEN',
  cookiesConsented: 'COOKIES_CONSENTED',
  deviceId: 'DEVICE_ID',
} as const
